import { FC, useCallback, useMemo } from "react";
import { ForecastedCostRe, ForecastOption } from "@/services/cloudchipr.api";
import { DropdownSelect } from "@/components/common/select/dropdown-select/DropdownSelect";
import { HierarchySelectDropdownHeader } from "@/components/pages/common/hierarchy-select-visibility/components/HierarchySelectDropdownHeader";
import { ResourceExplorerForecastedCostsOption } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-metadata/components/forecasted/ResourceExplorerForecastedCostsOption";
import { ResourceExplorerForecastedCostsSelectTriggerComponent } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-metadata/components/forecasted/ResourceExplorerForecastedCostsSelectTriggerComponent";

interface ResourceExplorerForecastedCostsProps {
  forecastedCosts?: ForecastedCostRe;
  selectedForecastOption: ForecastOption;
  onForecastChange?(forecastOption: ForecastOption): void;
}

export const ResourceExplorerForecastedCostsSelect: FC<
  ResourceExplorerForecastedCostsProps
> = ({ forecastedCosts, onForecastChange, selectedForecastOption }) => {
  const submitHandlerOnClose = useCallback(
    (selectedValues: string[]) => {
      const value = selectedValues[0] as ForecastOption;
      onForecastChange?.(value);
    },
    [onForecastChange],
  );

  const options = useMemo(() => {
    return forecastedCosts?.map((item) => {
      return {
        value: item.forecast_option,
        label: (
          <ResourceExplorerForecastedCostsOption
            cost={item.cost}
            key={item.forecast_option}
            forecastOption={item.forecast_option}
            dateFrom={item.date_from}
            dateTo={item.date_to}
          />
        ),
      };
    });
  }, [forecastedCosts]);

  return (
    <DropdownSelect
      singleSelect
      sortSelectedOptions={false}
      showSearch={false}
      label="Forecasted Cost"
      options={options ?? []}
      values={[selectedForecastOption ?? ""]}
      submitHandlerOnClose={submitHandlerOnClose}
      TriggerComponent={ResourceExplorerForecastedCostsSelectTriggerComponent}
      DropdownHeader={HierarchySelectDropdownHeader}
    />
  );
};
